import CallInfo from './CallInfo';
import CallAttributes from './CallAttributes';
import Wisdom from './Wisdom';
import Wrapup from './Wrapup';
import Dailpad from './Dailpad';
import CallContacts from './CallContacts';
import SBS from './SBS';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';

const CallDetails = () => {
    const agentObj = useSelector((state: any) => { return state.agentSlice.agentObj })
    const contactData = useSelector((state:any)=>{return state.contactAttributeSlice?.contactAttributes});

    useEffect(() => {
        if(agentObj.getState().name === "Busy") {
            //Aquí es la razón de por qué no funciona SbS si no es con los atributos (no sé que tendríamos que cambiar para que funcione con la nueva cajita)
            if(contactData[0]["contactAttributes"]["DefaultFlowForAgentUI"]) {
                const currentContactId = contactData.contactId;
                const contactflowId = contactData[0]["contactAttributes"]["DefaultFlowForAgentUI"].value;
                const customViewsIframe = document.querySelector('#customviews-container')!;
                customViewsIframe.setAttribute('src', `${process.env.REACT_APP_AWS_CCP_LOGIN_URL}stargate/app?contactFlowId=${contactflowId}&currentContactId=${currentContactId}`);
            }
        }
    }, []);
    
    if(process.env.REACT_APP_AWS_CCP_SbSAvailable === "1") {
        const customViewsIframe = document.querySelector('#customviews-container')!;
        customViewsIframe.setAttribute('style', "height: 43rem; width: 92%; margin: 0 auto; display: block; margin-left: 105px; margin-top: 10px; background-color: white;");    
    }

    return (
        <div className="main-content">
            <div className='container-fluid'>
                <div className='row'>
                    <div className='col-12'>
                        <CallInfo />
                    </div>
                </div>
                <div className='row'>
                    <div className='col-md-3'>
                        <CallContacts />
                    </div>
                    <div className='col-md-6'>
                        <CallAttributes />
                    </div>
                    <div className='col-md-3'>
                        <Wrapup />
                    </div>
                </div>
                <div className='row'>
                    <div className='col-md-12'>
                        <Wisdom />
                    </div>
                </div>
                {process.env.REACT_APP_AWS_CCP_SbSAvailable === "1" ? (
                    <div className='row'>
                        <div className='col-md-12'>
                            <SBS />
                        </div>
                    </div>
                ):(
                    <></>
                )}
            </div>
            <Dailpad />
        </div>
    )
}
export default CallDetails;
